<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
	mounted() {
		// document.dispatchEvent(new Event('render-event'));
	},
}
</script>

<style>
  *{
    padding: 0;
    margin: 0;
  }
  /* .el-main{
    padding: 0;
  } */
</style>



// WEBPACK FOOTER //
// src/App.vue